<template>
  <form name="frmLogin" method="post" @submit.prevent="onSubmitLogin" class="form">
    <div class="form-group">
      <label>Enter CMS User Account</label> <!-- CMS 사용자 계정 입력 -->
      <div class="input-wrapper">
        <input v-model.trim="uid" id="uid" type="text" name="uid" maxlength="10" class="input" />
        <button type="button" class="btn-one-time" @click="onGenerateOneTimePassword">
          Issue One-Time Password <!-- 1회성 비밀번호 발급 -->
        </button>
      </div>
    </div>

    <div class="form-group">
      <label>CMS Email Authentication Key</label> <!-- CMS 이메일 인증키 -->
      <input v-model.trim="uemail" id="uemail" type="text" name="uemail" maxlength="200" class="input" />
      <p class="hint">* Enter the authentication key you received via email.</p> <!-- * 이메일에서 받은 인증키정보를 입력합니다. -->
    </div>

    <button type="button" class="btn-reset" @click="onResetPassword">
      Reset Password <!-- 비밀번호 초기화 -->
    </button>
  </form>
</template>
  <script>
  import { generateOneTimePassword, resetPassword } from "@/Service/Login/pwdUnlock"; 
  
  export default {
    name: "pwdunlock",
    data() {
      return {
        uid: "",
        uemail: "",
      };
    },
    methods: {
      onGenerateOneTimePassword() {
        if (!this.uid) {
          alert("Please enter your CMS user account.");
          this.$nextTick(() => this.$refs.uid.focus());
          return;
        }
        generateOneTimePassword(this.uid); // Call the service
      },
      onResetPassword() {
        if (!this.uid) {
          alert("Please enter your CMS user account.");
          this.$nextTick(() => this.$refs.uid.focus());
          return;
        }
        resetPassword(this.uid,this.uemail); // Call the service
      },
      onSubmitLogin() {
        // Form submission logic can go here if needed
      },
    },
  };
  </script>
  
